import type { FC, SVGProps } from 'react';

const BloodPressureMonitorIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="10.7559"
      height="13.7535"
      rx="0.881633"
      transform="matrix(1 0 0 -1 4.9707 17.1143)"
      fill="currentColor"
    />
    <ellipse
      cx="2.11592"
      cy="2.6449"
      rx="2.11592"
      ry="2.6449"
      transform="matrix(1 0 0 -1 16.7847 12.1768)"
      fill="currentColor"
    />
    <path
      d="M9.20264 19.23H10.7896V15.8798H9.20264V19.23Z"
      fill="currentColor"
    />
    <path d="M18.019 19.23H19.6059V10.7663H18.019V19.23Z" fill="currentColor" />
    <path
      d="M9.20264 19.23C9.20264 20.0091 9.83419 20.6406 10.6132 20.6406H18.1953C18.9743 20.6406 19.6059 20.0091 19.6059 19.23V19.0537H9.20264V19.23Z"
      fill="currentColor"
    />
    <path
      d="M10.4371 10.5014C10.4371 8.3103 8.66089 6.53406 6.46979 6.53406C4.27868 6.53406 2.50244 8.3103 2.50244 10.5014C2.50244 12.6925 4.27868 14.4688 6.46979 14.4688C8.66089 14.4688 10.4371 12.6925 10.4371 10.5014ZM3.60165 10.5014C3.60165 8.91738 4.88576 7.63327 6.46979 7.63327C8.05382 7.63327 9.33792 8.91738 9.33792 10.5014C9.33792 12.0854 8.05382 13.3695 6.46979 13.3695C4.88576 13.3695 3.60165 12.0854 3.60165 10.5014Z"
      fill="currentColor"
    />
    <path
      d="M3.60165 10.5014C3.60165 8.91738 4.88576 7.63327 6.46979 7.63327C8.05382 7.63327 9.33792 8.91738 9.33792 10.5014C9.33792 12.0854 8.05382 13.3695 6.46979 13.3695C4.88576 13.3695 3.60165 12.0854 3.60165 10.5014Z"
      fill="#F2F2FB"
    />
    <rect
      width="1.13469"
      height="2.92214"
      rx="0.567345"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 5.5791 10.5898)"
      fill="currentColor"
    />
  </svg>
);

export default BloodPressureMonitorIcon;
